import { VectorSortHelper } from './../../../misc/VectorSortHelper';
import { BasicLayoutManager } from "../../view/BasicLayoutManager";
import { BasicProperties } from "../../view/BasicProperties";
import { BasicDialogVO } from "../../vo/BasicDialogVO";

export class BasicDialogHandler {
    protected static dialogHandler: BasicDialogHandler;
    public static PRIORITY_LOW: number = 1;
    public static PRIORITY_MIDDLE: number = 2;
    public static PRIORITY_HIGH: number = 3;
    public static PRIORITY_TOP: number = 4;
    protected _dialogs: BasicDialogVO[];
    private _dialog: BasicDialogVO;
    private _blockDialogs: boolean = false;

    constructor() {
        this.init();

        if (BasicDialogHandler.dialogHandler) {
            throw new Error("Calling constructor not allowed! Use getInstance instead.");
        }
    }

    public init(): void {
        this._dialogs = [];
    }

    public static getInstance(): BasicDialogHandler {
        if (!BasicDialogHandler.dialogHandler) {
            BasicDialogHandler.dialogHandler = new BasicDialogHandler();
        }
        return (<BasicDialogHandler>BasicDialogHandler.dialogHandler);
    }

    /**
     * Fügt DialogEigenschaften der Dialogliste hinzu
     *
     * @param key Object
     * @param properties BasicDialogProperties
     * @param blockDialogs Boolean
     * @param priority String
     * @param delay Number (in Miliseconds) no Function yet
     */
    public registerDialogs(key: Object, properties: BasicProperties = null, blockDialogs: boolean = false, priority: number = BasicDialogHandler.PRIORITY_LOW, delay: number = 0): void {
        /*if (!_dialogs)
         init();*/
        let dialog: BasicDialogVO = new BasicDialogVO();

        dialog.key = key;
        dialog.properties = properties;
        dialog.blockDialogs = blockDialogs;
        dialog.delay = delay;
        dialog.priority = priority;

        this._dialogs.push(dialog);

        // use a stable sort algorithm (vector search method is not stable!)
        VectorSortHelper.sort(this._dialogs, this.sortDialogs);
    }

    /**
     *    sortiert Dialogs
     *
     *     @param x:BasicDialogVO
     *    @param y:BasicDialogVO
     *
     *     @return Number
     **/
    private sortDialogs(x: BasicDialogVO, y: BasicDialogVO): number {
        if (x.priority > y.priority) {
            return -1;
        }

        if (x.priority < y.priority) {
            return 1;
        }

        return 0;
    }

    public forceShowDialog(name: string): void {
        if (!this.isThereADialog) {
            return;
        }

        for (let dialog of this._dialogs) {
            if (dialog.key === name) {
                this._dialog = this._dialogs.shift();
                this._blockDialogs = (this._blockDialogs || this._dialog.blockDialogs);
                this.layoutManager.showDialog(this._dialog.key, this._dialog.properties);
            }
        }

    }

    /**
     *    zeigt Dialog an wen
     *         - delay abgelaufen
     *         - Dialoge nicht blockiert
     *
     *     @param now:Number
     *
     **/
    public showDialog(now: number = 0): void {
        if (!this.isThereADialog) {
            return;
        }

        if (!this._blockDialogs) {
            this.performDialogDisplay();
        }
    }

    protected performDialogDisplay(): void {
        this._dialog = this._dialogs.shift();
        this._blockDialogs = this._dialog.blockDialogs;
        this.layoutManager.showDialog(this._dialog.key, this._dialog.properties);
    }

    /**
     *    cleart Dialog
     *
     *
     **/
    public onHideCurrentDialog(): void {
        if (this._dialog) {
            this._dialog = null;
            this.blockDialogs = false;
        }
    }

    public removeDialog(name: Object): void {
        for (let i: number = 0; i < this._dialogs.length; i++) {
            if (this._dialogs[i].key === name) {
                this._dialogs.splice(i, 1);
                i = -1;
            }
        }
    }

    public isDialogRegistered(key: Object): boolean {
        for (let i: number = 0; i < this._dialogs.length; i++) {
            if (this._dialogs[i].key === key) {
                return true;
            }
        }
        return false;
    }

    public get isThereADialog(): boolean {
        return (this._dialogs.length > 0);
    }

    public destroy(): void {
        this._dialogs = [];
    }

    protected get layoutManager(): BasicLayoutManager {
        return BasicLayoutManager.getInstance();
    }

    public get blockDialogs(): boolean {
        return this._blockDialogs;
    }

    public set blockDialogs(value: boolean) {
        this._blockDialogs = value;
    }

}

